import classNames from 'classnames';
import { Link } from 'react-router-dom';

import Icons from 'assets/icons';

interface NavButtonProps {
  link?: string;
  text: string;
  customClass?: string;
  state?: unknown;
}

const NavButton = ({
  link,
  text,
  customClass,
  state,
}: NavButtonProps): React.JSX.Element => {
  const isExternal = !!link && /^https?:\/\//.test(link);
  const isMailto = !!link && /^mailto:/.test(link);

  const content = (
    <>
      <div className="text-sm font-semibold">{text}</div>
      <Icons.DoubleArrow customClass="h-2.5 w-2.5" />
    </>
  );

  const classes = classNames(
    'flex items-center gap-1.5 text-blue-800 hover:gap-2 hover:text-navy-800 transition-all',
    customClass,
  );

  return (
    <div className="inline-flex">
      {isExternal || isMailto ? (
        <a
          href={link}
          {...(isExternal ? { target: '_blank' } : {})}
          className={classes}
        >
          {content}
        </a>
      ) : (
        <Link to={{ pathname: link, state } as never} className={classes}>
          {content}
        </Link>
      )}
    </div>
  );
};

export default NavButton;
